module.exports = __webpack_public_path__ + "img/z4.e0f4894c.png";